import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { ButtonDirective } from '@bioreferencehealth/ui-kit';
import { Store } from '@ngxs/store';
import { AppFontSize } from 'src/app/enums/app-font-size.enum';
import { UpdateFontSize } from 'src/states';

@Component({
  selector: 'app-font-size-controls',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './font-size-controls.component.html',
  styleUrls: ['./font-size-controls.component.scss'],
  imports: [ButtonDirective],
  providers: [Store]
})
export class FontSizeControlsComponent {
  private readonly store: Store = inject(Store);
  public readonly AppFontSize = AppFontSize;
  public readonly activeFontSize = computed(() => this.fontSize() ?? AppFontSize.MEDIUM);
  public readonly activeFontSizeLabel = computed(() => {
    const fontSize = this.activeFontSize();
    return fontSize === AppFontSize.SMALL ? 'S' : fontSize === AppFontSize.MEDIUM ? 'M' : 'L';
  });
  public readonly activeFontSizeTitle = computed(() => {
    const fontSize = this.activeFontSize();
    return fontSize === AppFontSize.SMALL
      ? 'Small font (12px)'
      : fontSize === AppFontSize.MEDIUM
        ? 'Medium font (14px)'
        : 'Large font (16px)';
  });

  public readonly fontSize = input<AppFontSize | null>(null);
  public readonly isCollapsed = input(false);

  public onFontSizeChange(fontSize: AppFontSize): void {
    this.store.dispatch(new UpdateFontSize(fontSize));
  }
}
